export default __webpack_public_path__ + "static/heroBg-a99abcfeb2c555e009181d73bb18bdf5.png";